class Modal {
  constructor(el, opt) {
    this.el = el;
    this.scrollPosition = 0; // スクロール位置を保存する変数
    if ($("." + this.el).length > 0) {
      this.init();
    }
  }

  init() {
    // モーダルトリガー要素を取得
    const triggers = document.querySelectorAll('[class*="-modal-trigger"]');

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        // クラス名からモーダルIDを抽出
        const classList = Array.from(trigger.classList);
        const modalClass = classList.find((cls) =>
          cls.includes("-modal-trigger")
        );

        if (modalClass) {
          // -modal-triggerを-modalに置換してモーダル要素を特定
          const modalSelector =
            "." + modalClass.replace("-modal-trigger", "-modal");
          const modal = document.querySelector(modalSelector);

          if (modal) {
            // 現在のスクロール位置を保存
            this.scrollPosition =
              window.pageYOffset || document.documentElement.scrollTop;

            modal.classList.add("is-active");
            // モーダルを開く時にis-fixedクラスを追加
            document.body.classList.add("is-fixed");

            // スクロールバーを調整
            this.adjustScrollbar(modal);
          }
        }
      });
    });

    // モーダルを閉じる処理（オプション）
    this.setupCloseHandlers();
  }

  setupCloseHandlers() {
    // close-btnをクリックしたらモーダルを閉じる
    document.addEventListener("click", (e) => {
      if (e.target.closest(".close-btn") || e.target.closest(".btn")) {
        const modal =
          e.target.closest('[class*="-modal"]') || e.target.closest(".s-modal");
        if (modal) {
          modal.classList.remove("is-active");
          // モーダルを閉じる時にis-fixedクラスを削除
          this.removeIsFixed();
          // スクロール位置を復元
          this.restoreScrollPosition();
        }
      }

      // モーダル背景をクリックしたらモーダルを閉じる
      if (
        e.target.matches('[class*="-modal"]') &&
        e.target === e.currentTarget
      ) {
        e.target.classList.remove("is-active");
        // モーダルを閉じる時にis-fixedクラスを削除
        this.removeIsFixed();
        // スクロール位置を復元
        this.restoreScrollPosition();
      }

      // s-modal背景をクリックしたらモーダルを閉じる
      if (e.target.matches(".s-modal") && e.target === e.currentTarget) {
        e.target.classList.remove("is-active");
        // モーダルを閉じる時にis-fixedクラスを削除
        this.removeIsFixed();
        // スクロール位置を復元
        this.restoreScrollPosition();
      }
    });

    // ESCキーでモーダルを閉じる
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const activeModal =
          document.querySelector('[class*="-modal"].is-active') ||
          document.querySelector(".s-modal.is-active");
        if (activeModal) {
          activeModal.classList.remove("is-active");
          // モーダルを閉じる時にis-fixedクラスを削除
          this.removeIsFixed();
          // スクロール位置を復元
          this.restoreScrollPosition();
        }
      }
    });
  }

  // is-fixedクラスを削除する処理
  removeIsFixed() {
    // 他のモーダルが開いているかチェック
    const hasActiveModal =
      document.querySelector('[class*="-modal"].is-active') ||
      document.querySelector(".s-modal.is-active");

    // アクティブなモーダルがなければis-fixedクラスを削除
    if (!hasActiveModal) {
      document.body.classList.remove("is-fixed");
    }
  }

  // スクロール位置を復元する処理
  restoreScrollPosition() {
    // 他のモーダルが開いているかチェック
    const hasActiveModal =
      document.querySelector('[class*="-modal"].is-active') ||
      document.querySelector(".s-modal.is-active");

    // アクティブなモーダルがなければスクロール位置を復元
    if (!hasActiveModal) {
      // 少し遅延を入れてからスクロール位置を復元
      setTimeout(() => {
        window.scrollTo(0, this.scrollPosition);
      }, 10);
    }
  }
}

